module.exports = __webpack_public_path__ + "img/organization-x.ea0fab43.jpg";